import { InterfaceFactoryOptions } from './factory-options.interface';
import { Container } from '@tencent/alloy-renderer';
import { ElementBaseComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/base-component/element-base-component';
import { CANVAS_CONNECTOR_ID } from '@src/slide/content-viewer/service/canvas-renderer/core/id-constants';
import { IConnectorModel } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';

/**
 * 连接线模块
 */
export class RendererConnectorComponent extends Container {
    // 图形构造入参
    public factoryOptions: InterfaceFactoryOptions<IConnectorModel>;
    private baseComponent: ElementBaseComponent;

    public constructor(factoryOptions: InterfaceFactoryOptions<IConnectorModel>) {
        super();
        this.factoryOptions = factoryOptions;
        this.id = CANVAS_CONNECTOR_ID;

        // 图形渲染
        this.renderAllGraphic();
    }

    // factory层监听model变化，调用此函数刷新元素渲染
    public updateComponent = (): void => {
        this.renderAllGraphic();
    };

    public dispose() {
        super.dispose();
        this.destroyRelation();
    }

    // 所有图形模块渲染
    private renderAllGraphic = () => {
        // 基础图形部分
        this.renderBase();
        // 建立连接线与图形的连接关系
        this.buildRelation();
    };

    // 插入|更新 基础图形部分
    private renderBase = () => {
        if (!this.baseComponent) {
            this.baseComponent = new ElementBaseComponent(this.factoryOptions);
            this.addChild(this.baseComponent);
        }
        this.baseComponent.renderComponent();
    };

    // 建立连接线与图形的连接关系
    private buildRelation = () => {
        const { fromScale, model } = this.factoryOptions;
        if (!fromScale && model.getConnectorInfo()) {
            model.buildRelation();
        }
    };

    // 销毁连接线与图形的连接关系
    private destroyRelation = () => {
        const { fromScale, model } = this.factoryOptions;
        if (!fromScale) {
            const startModel = model.startUIModel;
            if (startModel && !startModel.selected) {
                if (!model.sdkData) {
                    model.props.style.connectorInfo.start = null;
                }
                startModel.removeRelatedUIModelRefs(model);
            }
            const endModel = model.endUIModel;
            if (endModel && !endModel.selected) {
                if (!model.sdkData) {
                    model.props.style.connectorInfo.end = null;
                }
                endModel.removeRelatedUIModelRefs(model);
            }
        }
    };
}
